import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\DeleteCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/DeleteCommandRunController.php
* @route '/api/sa-management/command-runner/runs/{commandRun}'
*/
const DeleteCommandRunController = (args: { commandRun: string | { id: string } } | [commandRun: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommandRunController.url(args, options),
    method: 'delete',
})

DeleteCommandRunController.definition = {
    methods: ["delete"],
    url: '/api/sa-management/command-runner/runs/{commandRun}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\SAManagement\DeleteCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/DeleteCommandRunController.php
* @route '/api/sa-management/command-runner/runs/{commandRun}'
*/
DeleteCommandRunController.url = (args: { commandRun: string | { id: string } } | [commandRun: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commandRun: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commandRun: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commandRun: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commandRun: typeof args.commandRun === 'object'
        ? args.commandRun.id
        : args.commandRun,
    }

    return DeleteCommandRunController.definition.url
            .replace('{commandRun}', parsedArgs.commandRun.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\DeleteCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/DeleteCommandRunController.php
* @route '/api/sa-management/command-runner/runs/{commandRun}'
*/
DeleteCommandRunController.delete = (args: { commandRun: string | { id: string } } | [commandRun: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommandRunController.url(args, options),
    method: 'delete',
})

export default DeleteCommandRunController